<script>
  import moment from 'moment'
  import LeilaoService from '../../../../domain/leiloes/services'
  import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
  import * as TiposRelatorioPreparacaoLeilao from '../../../../domain/leiloes/helpers/tipos-relatorios-preparacao'

  export default {
    components: {
      PopupViewer,
      // ResultadoGeracaoLotesLeilao: () => import('./ResultadoGeracaoLotesLeilao'),
      ResultadoImportacaoCsvGrv: () => import('./ResultadoImportacaoCsvGrv'),
      ResultadoImportacaoSecundariaLeilao: () => import('./ResultadoImportacaoSecundariaLeilao')
    },
    nome: 'historico-logs-importacao-preparacao-leilao',
    props: {
      leilaoId: {
        type: Number,
        default: () => 0,
        required: true
      },
      tipoLog: {
        type: String,
        required: true,
        validator: val => TiposRelatorioPreparacaoLeilao.FUNCOES_TIPOS_RELATORIO.hasOwnProperty(val)
      }
    },
    data () {
      return {
        isLoaded: false,
        historicoLogs: [],
        showViewer: false,
        logSelecionado: null,
        TiposRelatorioPreparacaoLeilao
      }
    },
    filters: {
      formatarData (date) {
        return moment(date).format('L LTS')
      }
    },
    created () {
      this.load()
    },
    methods: {
      load () {
        this.$loaderOverlay.open().message('Obtendos dados, aguarde...')
        const {fn} = TiposRelatorioPreparacaoLeilao.FUNCOES_TIPOS_RELATORIO[this.tipoLog]
        LeilaoService[fn](this.leilaoId)
          .then(result => {
            this.historicoLogs = result.data
            this.isLoaded = true
            this.$loaderOverlay.hide()
          })
          .catch(error => {
            alert('Ocorreu um erro ao obter os dados')
            console.log(error.data)
            this.$loaderOverlay.hide()
          })
      },
      openViewer () {
        this.showViewer = true
      },
      closeViewer () {
        this.showViewer = false
      },
      selecionaLog (log) {
        this.logSelecionado = log
        this.openViewer()
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Histórico de logs de importações</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel">
          <div class="panel-body">
            <div class="text-dark resultado-success m-t-xl" v-if="!historicoLogs.length">
              <i class="fa fa-warning fa-5x"></i>
              <span>{{TiposRelatorioPreparacaoLeilao.FUNCOES_TIPOS_RELATORIO[tipoLog].messageEmpty}}</span>
            </div>
            <div class="informacoes-historico m-b-lg" v-else>
              <div>Foram encontrados <span>{{historicoLogs.length}}</span> log{{historicoLogs.length !== 1 ? 's' : ''}} para este leilão</div>
            </div>
            <div v-if="historicoLogs.length">
              <table class="table-lotes-leilao table table-clicked table-striped bg-whit b-a">
                <thead>
                <tr>
                  <th class="text-nowrap text-center">Data da Importação</th>
                  <th class="text-nowrap text-center">Opções</th>
                </tr>
                </thead>
                <tbody>
                <tr class="leilao-list-lote-item" v-for="log in historicoLogs">
                  <td>{{log.data.date | formatarData}}</td>
                  <td>
                    <u-button class="btn btn-info btn-xs" @click="selecionaLog(log)"><i class="fa fa-eye"></i> Ver detalhes</u-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <popup-viewer @close="closeViewer" v-if="showViewer" title="Histórico de logs de importação">
        <!--TODO: DEIXAR DINÂMICO-->
        <ResultadoImportacaoCsvGrv :relatorio="logSelecionado" v-if="tipoLog === TiposRelatorioPreparacaoLeilao.TIPO_RELATORIO_CSV_GRV"/>
        <ResultadoImportacaoSecundariaLeilao :relatorio="logSelecionado" v-if="tipoLog === TiposRelatorioPreparacaoLeilao.TIPO_RELATORIO_IMPORTACAO_SECUNDARIA"/>
      </popup-viewer>
    </div>
  </transition>
</template>

<style scoped>
  td {
    text-align: center
  }
  .informacoes-historico {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  .informacoes-historico span {
    font-weight: bold;
  }
  .resultado-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
</style>



// WEBPACK FOOTER //
// HistoricoLogsImportacaoPreparacaoLeilao.vue?72ab9fbc